import { Dispatch } from "redux";
import {EncryptedDataActionTypes, EncryptedDataCreateAction, encryptedData} from "../../types/Encryption/encryption";
import axios from "axios";


const initialEncryptedData: encryptedData = {
    rtag: '',
};

interface ErrorResponse {
    code: number;
    message: string;
}

export const getEncryptedValue = (operator: string, rTag: string): any => {
    return async (dispatch: Dispatch<EncryptedDataCreateAction>) => {
        try {
            dispatch({ type: EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA });
            const response = await axios.get('/api/referral/encrypt', {
                params: {
                    operator: operator,
                    rtag: rTag
                },
                headers: { Accept: 'application/json' },
                
                paramsSerializer: params => {
                    const searchParams = new URLSearchParams();
                    for (const key in params) {
                        if (Array.isArray(params[key])) {
                            params[key].forEach((value: any) => {
                                searchParams.append(key, value);
                            });
                        } else {
                            searchParams.append(key, params[key]);
                        }
                    }
                    return searchParams.toString();
                },
                withCredentials: false
            });
            if (response.data) {
                dispatch({ type: EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA_SUCCESS, payload: response.data });
            } else {
                dispatch({ type: EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA_SUCCESS, payload: initialEncryptedData });
            }
        } catch (error: any) {

            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                if (typeof error.response.data === 'string') {
                    errorPayload = {
                        code: error.response.status,
                        message: error.response.data,
                    }
                } else {
                    const { code, message } = error.response.data;
                    errorPayload = { code, message };
                }
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA_ERROR, payload: errorPayload });
        }
    }
}
